export const ContentTypes = {
  RESOURCE: 'resource',
  STRATEGY: 'strategy',
  TEXT_RICH_TEXT: 'text_rich_text',
  TEXT_HEADER: 'text_header'
}
